module.exports = __webpack_public_path__ + "static/img/paixu04.a095aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/paixu04.png
// module id = 116
// module chunks = 0